// extracted by mini-css-extract-plugin
export var button = "index-module--button--xAKsz";
export var content = "index-module--content--Dl80q";
export var illustration = "index-module--illustration--uaK3u";
export var rotate = "index-module--rotate--KYlfN";
export var wrapper = "index-module--wrapper--M68rB";